<template>
    <div class="maluku-introduction">
        <p>{{ $t('maluku.introduction') }}</p>
        <h2>{{ $t('maluku.discoverNegeri') }}</h2>
        <p>{{ $t('maluku.seoNegeriDescription') }}</p>
        <h2>{{ $t('maluku.followNames') }}</h2>
        <p>{{ $t('maluku.seoFamiliesDescription') }}</p>
        <p>{{ $t('maluku.researchNote') }}</p>
    </div>
</template>

<style scoped>
.maluku-introduction h2 { margin: 20px 0 8px; font-size: 1.125rem; line-height: 1.4; }
.maluku-introduction p { margin: 0 0 14px; line-height: 1.6; }
</style>
